
export default function WhiteThinLine()
{
    return (
        <div>
            <hr style={{ borderWidth: "0.5px", borderColor: "white", width: "25%",    
                        marginLeft: "auto", marginRight: "auto" }} /> <br />
        </div>
    );
}

export function WhiteThickLine()
{
    return (
        <div>
            <hr style={{ borderWidth: "1.5px", borderColor: "white", width: "90%",          
                        marginLeft: "auto", marginRight: "auto", marginTop: "1rem" }} />

            <br /> <br /> <br /> <br />
        </div>
    );
}